<highcharts-chart
        [constructorType]="chartConstructor"
        [options]="chartOptions"
/>